export default {
  displayFont: '"Trocchi", serif',
  altDisplayFont: '"Ultra", serif',
  bodyFont: '"Raleway", Helvetica, sans-serif',
  fontSizes: {
    xxl: {
      xs: {
        fs: 40,
        lh: 40,
        ls: 0.5
      },
      sm: {
        fs: 70,
        lh: 70,
        ls: 0.5
      },
      md: {
        fs: 80,
        lh: 80,
        ls: 0.5
      },
      lg: {
        fs: 80,
        lh: 80,
        ls: 0.5
      },
      xl: {
        fs: 80,
        lh: 80,
        ls: 0.5
      }
    },
    xl: {
      xs: {
        fs: 32,
        lh: 40,
        ls: 0
      },
      sm: {
        fs: 32,
        lh: 40,
        ls: 0
      },
      md: {
        fs: 40,
        lh: 50,
        ls: 0
      },
      lg: {
        fs: 40,
        lh: 50,
        ls: 0
      },
      xl: {
        fs: 40,
        lh: 50,
        ls: 0
      }
    },
    lg: {
      xs: {
        fs: 24,
        lh: 32,
        ls: 0
      },
      sm: {
        fs: 24,
        lh: 32,
        ls: 0
      },
      md: {
        fs: 32,
        lh: 40,
        ls: 0
      },
      lg: {
        fs: 32,
        lh: 40,
        ls: 0
      },
      xl: {
        fs: 32,
        lh: 40,
        ls: 0
      }
    },
    md: {
      xs: {
        fs: 22,
        lh: 26,
        ls: 0.5
      },
      sm: {
        fs: 22,
        lh: 26,
        ls: 0.5
      },
      md: {
        fs: 28,
        lh: 34,
        ls: 0.5
      },
      lg: {
        fs: 28,
        lh: 34,
        ls: 0.5
      },
      xl: {
        fs: 28,
        lh: 34,
        ls: 0.5
      }
    },
    sm: {
      xs: {
        fs: 16,
        lh: 22,
        ls: 0.5
      },
      sm: {
        fs: 16,
        lh: 22,
        ls: 0.5
      },
      md: {
        fs: 18,
        lh: 24,
        ls: 0.5
      },
      lg: {
        fs: 18,
        lh: 24,
        ls: 0.5
      },
      xl: {
        fs: 18,
        lh: 24,
        ls: 0.5
      }
    },
    xs: {
      xs: {
        fs: 12,
        lh: 16,
        ls: 0
      },
      sm: {
        fs: 12,
        lh: 16,
        ls: 0
      },
      md: {
        fs: 14,
        lh: 20,
        ls: 0
      },
      lg: {
        fs: 14,
        lh: 20,
        ls: 0
      },
      xl: {
        fs: 14,
        lh: 20,
        ls: 0
      }
    },
    xxs: {
      xs: {
        fs: 12,
        lh: 16,
        ls: 0
      },
      sm: {
        fs: 12,
        lh: 16,
        ls: 0
      },
      md: {
        fs: 12,
        lh: 16,
        ls: 0
      },
      lg: {
        fs: 12,
        lh: 16,
        ls: 0
      },
      xl: {
        fs: 12,
        lh: 16,
        ls: 0
      }
    }
  },
  fontWeights: {
    extraLight : 200,
    light      : 300,
    normal     : 400,
    medium     : 500,
    semiBold   : 600,
    bold       : 700,
    black      : 900,
  },
  colors: {
    tones: {
      lightest : '#EEEEEA',
      lighter  : '#C6C6C3',
      light    : '#9C9C9A',
      dark     : '#737372',
      darker   : '#4A4A4A',
    },
    primary         : '#7D9BAE',
    primaryDark     : '#738CA0',
    primaryDarker   : '#698296',
    primaryDarkest  : '#55697B',
    secondary       : '#EEEEEA',
    secondaryDark   : '#E6E6E1',
    secondaryDarker : '#DEDED6',
    background      : '#EEEEEA',
    text            : '#737372',
    danger          : '#FA643C'
  },
  navHeight: 60,
  grid: {
    breakpoints: { // defaults below
      giant   : 1200,
      xl      : 1200,
      desktop : 992,
      lg      : 992,
      tablet  : 768,
      md      : 768,
      phone   : 576,
      sm      : 576,
      smaller : 575,
      xs      : 575,
    },
    row: {
      padding: 20, // default 15
    },
    col: {
      padding: 20, // default 15
    },
    container: {
      padding: 40, // default 15
      paddingXs: 20
    }
  }
};



// WEBPACK FOOTER //
// ./src/ui/styles/theme.js